import { Button } from "primereact/button";
import { useNavigate } from "react-router";
import { AuthenticationFactory } from "../services/Auth/AuthenticationFactory";

const Unauthorized = () => {
    const navigate = useNavigate();

    const authSvc = AuthenticationFactory.getAuthService(import.meta.env.VITE_AUTH_PROVIDER);
    return (
        <div className="unauthorized">
            <div>
                <div>
                    <h2>You are not authorized to access this page.</h2>
                </div>
                <div className="unauthorized">
                    <Button link onClick={() => { navigate('/'); }}>Return to Home</Button>
                    <Button link onClick={() => { authSvc.logout(true); }}>Logout</Button>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;